import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { PriceLevelsFacade } from './+state';
import { PriceLevelsStateModule } from './+state/price-levels.state.module';
import { PriceLevelsService } from './services';

@NgModule({
  imports: [CommonModule, PriceLevelsStateModule],
})
export class DomainPriceLevelsModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainPriceLevelsModule,
      providers: [PriceLevelsService, PriceLevelsFacade],
    };
  }
}
